// 1) NA GÓRZE PLIKU – ZAMIANA importów:
import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./leasing-form.css";
import { useNavigate } from "react-router-dom";


/* ===================== FAVICON ===================== */
const faviconUrl = "https://aureus.pl/bezplatna-konsultacja/favicon.ico";
const existingLink = document.querySelector('link[rel~="icon"]');
if (existingLink) existingLink.href = faviconUrl;
else {
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = faviconUrl;
  link.type = "image/png";
  document.head.appendChild(link);
}

/* ===================== FONT: Lato ===================== */
const LATO_HREF =
  "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;700&display=swap";
if (!document.querySelector('link[data-font="lato"]')) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = LATO_HREF;
  link.setAttribute("data-font", "lato");
  document.head.appendChild(link);
}

/* ===================== WALIDACJE ===================== */
function validatePhone(v) {
  const s = String(v || "").replace(/[^\d+]/g, "");
  return s.length >= 7;
}
function validateEmail(v) {
  if (!v) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
}

/* ====== SLOTY 30 min, pn–pt 08:00–16:00 ====== */
const SLOT_MINUTES = 30;
const START_HOUR = 8;
const END_HOUR = 16;



function pad(n) { return String(n).padStart(2, "0"); }
function isBusinessDay(date) { const dow = date.getDay(); return dow >= 1 && dow <= 5; }
function nextBusinessDate(from = new Date()) {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  do { d.setDate(d.getDate() + 1); } while (!isBusinessDay(d));
  return d;
}
function dateToInputValue(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }
function baseTimeOptions() {
  const opts = [];
  for (let h = START_HOUR; h < END_HOUR; h++) {
    for (let m = 0; m < 60; m += SLOT_MINUTES) {
      if (h === END_HOUR - 1 && m > 30) break;
      opts.push(`${pad(h)}:${pad(m)}`);
    }
  }
  return opts;
}
const ALL_TIME_OPTIONS = baseTimeOptions();

function composeDateTime(dateStr, timeStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const [hh, mm] = timeStr.split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, 0, 0);
}
function addMinutes(date, mins) { const d = new Date(date.getTime()); d.setMinutes(d.getMinutes() + mins); return d; }
function formatHuman(dt) {
  const y = dt.getFullYear(), m = pad(dt.getMonth() + 1), d = pad(dt.getDate());
  const hh = pad(dt.getHours()), mm = pad(dt.getMinutes());
  return `${d}.${m}.${y} ${hh}:${mm}`;
}
function ymd(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }
function isTodayStr(s) { return !!s && s === ymd(new Date()); }
function roundUpToNextSlot(date) {
  const d = new Date(date); d.setSeconds(0, 0);
  const rem = d.getMinutes() % SLOT_MINUTES;
  if (rem !== 0) d.setMinutes(d.getMinutes() + (SLOT_MINUTES - rem));
  return d;
}
function buildTimeOptionsForDate(dateStr, now = new Date()) {
  if (!dateStr) return ALL_TIME_OPTIONS;
  if (!isTodayStr(dateStr)) return ALL_TIME_OPTIONS;
  const cutoff = roundUpToNextSlot(now);
  const ch = cutoff.getHours(), cm = cutoff.getMinutes();
  if (ch >= END_HOUR) return [];
  return ALL_TIME_OPTIONS.filter((t) => {
    const [hh, mm] = t.split(":").map(Number);
    if (hh < ch) return false;
    if (hh === ch && mm < cm) return false;
    return true;
  });
}

/* ===================== POPUP POLITYKI ===================== */
function PrivacyPopup({ onClose }) {
  return createPortal(
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>&times;</button>
        <h2>Polityka prywatności</h2>
        <div style={{ maxHeight: "60vh", overflowY: "auto", textAlign: "left", fontSize: 14 }}>
          <p><strong>Administrator danych:</strong><br/>Aureus Leasing Sp. z o.o., ul. Jasnogórska 3, lok. B4, 44-100 Gliwice, NIP 6312644058, REGON 242799493.</p>
          <p><strong>Cel i podstawa przetwarzania:</strong><br/>Umówienie i przeprowadzenie konsultacji oraz przedstawienie możliwych rozwiązań finansowania/ubezpieczenia (art. 6 ust. 1 lit. b i f RODO).</p>
          <p><strong>Odbiorcy danych:</strong><br/>Partnerzy finansowi/ubezpieczeniowi i partnerzy techniczni obsługujący formularz.</p>
          <p><strong>Okres przechowywania:</strong><br/>Do realizacji celu lub cofnięcia zgody marketingowej.</p>
          <p><strong>Prawa:</strong> dostęp, sprostowanie, usunięcie, ograniczenie, przeniesienie, sprzeciw.</p>
          <p><strong>Kontakt:</strong> <a href="mailto:biuro@aureus.pl">biuro@aureus.pl</a></p>
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ===================== GŁÓWNY KOMPONENT ===================== */
export default function LeasingForm() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sent] = useState(false);
  const navigate = useNavigate();

  

  

  const today = new Date();
  const initialDate = isBusinessDay(today) ? ymd(today) : dateToInputValue(nextBusinessDate(today));
  const [now, setNow] = useState(new Date());

const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  consentContact: false,
  privacyAccepted: false,
  meetingDate: "",   // <-- puste, nie domyślna data
  meetingTime: "",
});

  const [timeOptions, setTimeOptions] = useState(buildTimeOptionsForDate(initialDate, now));
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const showError = (name) => (submitted || touched[name]) && errors[name];

  // refs + helper do wyświetlenia daty
 // --- refs i helpery do natywnych pickerów (MUSZĄ być w komponencie) ---
const dateRef = useRef(null);
const timeRef = useRef(null);

const openNativeDate = () => {
  if (!dateRef.current) return;
  if (typeof dateRef.current.showPicker === "function") {
    dateRef.current.showPicker();     // Chrome/Edge/Safari 16.4+
  } else {
    dateRef.current.focus();
    dateRef.current.click();          // fallback
  }
};

const openNativeTime = () => {
  if (!timeRef.current) return;
  timeRef.current.focus();
  timeRef.current.click();
};
  function formatDateHumanYMD(ymdStr) {
    if (!ymdStr) return "";
    const [y, m, d] = ymdStr.split("-").map(Number);
    return `${String(d).padStart(2,"0")}.${String(m).padStart(2,"0")}.${y}`;
  }

  
useEffect(() => {

    const params = new URLSearchParams(window.location.search);

    const qr = params.get("qr");

    if (!qr) return;

    fetch(
        `/bezplatna-konsultacja/qr-log.php?qr=${encodeURIComponent(qr)}`,
        {
            method: "GET",
            cache: "no-store"
        }
    );

}, []);

  useEffect(() => { document.title = "Leasing i ubezpieczenia – bezpłatna konsultacja | Aureus"; }, []);
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(id); }, []);

  useEffect(() => {
    const opts = buildTimeOptionsForDate(formData.meetingDate, now);
    if (isTodayStr(formData.meetingDate) && opts.length === 0) {
      const next = dateToInputValue(nextBusinessDate(new Date()));
      setFormData((p) => ({ ...p, meetingDate: next, meetingTime: "" }));
      setTimeOptions(ALL_TIME_OPTIONS);
    } else {
      setTimeOptions(opts);
      if (formData.meetingTime && !opts.includes(formData.meetingTime)) {
        setFormData((p) => ({ ...p, meetingTime: "" }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.meetingDate, now]);

  const buildErrors = (data) => {
    const e = {};
    if (!data.firstName.trim()) e.firstName = "Podaj imię.";
    if (!data.lastName.trim()) e.lastName = "Podaj nazwisko.";
    if (!validatePhone(data.phone)) e.phone = "Podaj poprawny numer telefonu.";
    if (!validateEmail(data.email)) e.email = "Podaj poprawny adres e-mail.";
    if (data.meetingDate) {
      const d = new Date(data.meetingDate + "T00:00:00");
      if (!isBusinessDay(d)) e.meetingDate = "Wybierz dzień roboczy (pon.–pt.).";
    }
    if (data.meetingTime) {
      const opts = buildTimeOptionsForDate(data.meetingDate, new Date());
      if (!opts.includes(data.meetingTime)) e.meetingTime = "Wybierz godzinę z listy (08:00–16:00, co 30 min).";
      if (data.meetingDate) {
        const start = composeDateTime(data.meetingDate, data.meetingTime);
        if (start.getTime() < Date.now()) e.meetingTime = "Wybierz termin w przyszłości.";
      }
    }
    if (!data.consentContact) e.consentContact = "Zaznacz zgodę na kontakt w sprawie konsultacji.";
    if (!data.privacyAccepted) e.privacyAccepted = "Zaakceptuj politykę prywatności.";
    return e;
  };

  const onChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => {
      const next = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (submitted || touched[name]) setErrors(buildErrors(next));
      return next;
    });
  };
  const onBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors(buildErrors(formData));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    if (!value) {
      setFormData((p) => ({ ...p, meetingDate: value, meetingTime: "" }));
    } else {
      const picked = new Date(value + "T00:00:00");
      if (!isBusinessDay(picked)) {
        const corrected = nextBusinessDate(picked);
        const correctedStr = dateToInputValue(corrected);
        setFormData((p) => ({ ...p, meetingDate: correctedStr, meetingTime: "" }));
      } else {
        setFormData((p) => ({ ...p, meetingDate: value }));
      }
    }
    setTouched((prev) => ({ ...prev, meetingDate: true }));
    setErrors(buildErrors({ ...formData, meetingDate: value }));
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    const e = buildErrors(formData);
    setErrors(e);
    if (Object.keys(e).length > 0) return;

    let meetingStartISO = "", meetingEndISO = "", meetingStartHuman = "", meetingEndHuman = "";
    if (formData.meetingDate && formData.meetingTime) {
      const start = composeDateTime(formData.meetingDate, formData.meetingTime);
      const end = addMinutes(start, SLOT_MINUTES);
      meetingStartISO = start.toISOString();
      meetingEndISO = end.toISOString();
      meetingStartHuman = formatHuman(start);
      meetingEndHuman = formatHuman(end);
    }

    const payload = {
      ...formData,
      meetingStartISO, meetingEndISO, meetingStartHuman, meetingEndHuman,
      slotDurationMin: SLOT_MINUTES, form_id: "consultation_last_step_v2",
    };

    try {
      setIsSubmitting(true);
      await fetch("https://aureus.pl/bezplatna-konsultacja/obsluga-wysylki/send.php", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
      });
      localStorage.setItem("consultation_form", JSON.stringify(payload));
      navigate("/bezplatna-konsultacja/podsumowanie");
    } catch {
      alert("Wystąpił błąd przy wysyłaniu. Spróbuj ponownie.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (sent) return null;

  const errStyle = { color: "#b91c1c", fontSize: 12, marginTop: 6, lineHeight: 1.3 };

  /* === BANER === */
  const BANNER_URL = process.env.PUBLIC_URL + "/images/baner-aureus-konsultacje-down.jpeg";
  const AUREUS_LOGO_URL = process.env.PUBLIC_URL + "/images/aureus_logo-white-ok.svg";

  return (
    <div className="leasing-form">
      <header className="header">
        <div className="hero-banner">
          <img src={BANNER_URL} alt="Bezpłatna konsultacja z ekspertem Aureus" className="hero-banner-img" loading="eager" />
          <div className="hero-overlay">
            <div className="hero-logo-row">
              <img src={AUREUS_LOGO_URL} alt="Aureus" className="hero-logo" />
            </div>
            <div className="hero-copy">
              <h1 className="hero-title">
                Bezpłatna konsultacja<br />z ekspertem Aureus
              </h1>
              <p className="hero-lead">
                Porozmawiaj z doradcami, którzy znają realia biznesu. Pokażemy Ci, jakie opcje
                są dostępne i jak mogą przełożyć się na realne oszczędności, większą elastyczność
                czy bezpieczeństwo Twojej firmy.
              </p>
              <div className="hero-tags">
                LEASING I FINANSOWANIE&nbsp;|&nbsp;UBEZPIECZENIA&nbsp;|&nbsp;KSIĘGOWOŚĆ I DORADZTWO&nbsp;|&nbsp;DOTACJE
              </div>
            </div>
          </div>
        </div>
      </header>

      

      <main className="form-step">
        {/* Imię / Nazwisko / Telefon / Email */}
        <div className="group-layout columns-zgody zgody-compact" style={{ width: "100%" }}>
          <div className={`form-field ${showError("firstName") ? "error" : ""}`}>
            <input type="text" name="firstName" value={formData.firstName}
              onChange={onChange} onBlur={onBlur} placeholder="Imię" aria-invalid={!!showError("firstName")} />
            {showError("firstName") && <div className="field-error" style={errStyle}>{errors.firstName}</div>}
          </div>

          <div className={`form-field ${showError("lastName") ? "error" : ""}`}>
            <input type="text" name="lastName" value={formData.lastName}
              onChange={onChange} onBlur={onBlur} placeholder="Nazwisko" aria-invalid={!!showError("lastName")} />
            {showError("lastName") && <div className="field-error" style={errStyle}>{errors.lastName}</div>}
          </div>

          <div className={`form-field ${showError("phone") ? "error" : ""}`}>
            <input type="text" name="phone" value={formData.phone}
              onChange={onChange} onBlur={onBlur} placeholder="Telefon" aria-invalid={!!showError("phone")} />
            {showError("phone") && <div className="field-error" style={errStyle}>{errors.phone}</div>}
          </div>

          <div className={`form-field ${showError("email") ? "error" : ""}`}>
            <input type="email" name="email" value={formData.email}
              onChange={onChange} onBlur={onBlur} placeholder="E-mail" aria-invalid={!!showError("email")} />
            {showError("email") && <div className="field-error" style={errStyle}>{errors.email}</div>}
          </div>
        </div>



        {/* Termin rozmowy – inline fields */}
       {/* 3) W SEKCJI "Termin rozmowy" – dodaj onClick do całego wiersza */}
<div className="slot-grid">
  {/* DATA */}
  <div className={`form-field inline-field ${showError("meetingDate") ? "error" : ""}`}>
    <div className="inline-control" onClick={openNativeDate}>
      <span className="inline-label">Data rozmowy</span>
      <span className={`inline-value ${!formData.meetingDate ? "placeholder" : ""}`}>
        {formData.meetingDate ? formatDateHumanYMD(formData.meetingDate) : "-- wybierz --"}
      </span>
      <input
        ref={dateRef}
        type="date"
        name="meetingDate"
        value={formData.meetingDate}
        min={ymd(isBusinessDay(new Date()) ? new Date() : nextBusinessDate(new Date()))}
        onChange={handleDateChange}
        onBlur={onBlur}
        aria-invalid={!!showError("meetingDate")}
        className="native-overlay"
      />
    </div>
    <p className="field-subtitle">Dostępne są tylko dni robocze (pon.–pt.).</p>
    {showError("meetingDate") && (
      <div className="field-error" style={{ color:"#b91c1c", fontSize:12, marginTop:6, lineHeight:1.3 }}>
        {errors.meetingDate}
      </div>
    )}
  </div>

  {/* GODZINA */}
  <div className={`form-field inline-field ${showError("meetingTime") ? "error" : ""}`}>
    <div className="inline-control" onClick={openNativeTime}>
      <span className="inline-label">Godzina rozmowy</span>
      <span className={`inline-value ${!formData.meetingTime ? "placeholder" : ""}`}>
        {formData.meetingTime || "-- wybierz --"}
      </span>
      <select
        ref={timeRef}
        name="meetingTime"
        value={formData.meetingTime}
        onChange={onChange}
        onBlur={onBlur}
        aria-invalid={!!showError("meetingTime")}
        className="native-overlay"
      >
        <option value=""></option>
        {timeOptions.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
    </div>
    <p className="field-subtitle">
      Konsultacja trwa zwykle do 30 minut. Spotkania umawiamy w dni robocze między 08:00 a 16:00.
    </p>
    {showError("meetingTime") && (
      <div className="field-error" style={{ color:"#b91c1c", fontSize:12, marginTop:6, lineHeight:1.3 }}>
        {errors.meetingTime}
      </div>
    )}
  </div>
</div>


        {/* Zgody */}
        <div className={`form-field checkbox-field ${showError("consentContact") ? "error" : ""}`} style={{ marginTop: 8 }}>
          <label className="checkbox-option-block">
            <input type="checkbox" name="consentContact" checked={!!formData.consentContact}
              onChange={onChange} onBlur={onBlur} aria-invalid={!!showError("consentContact")} />
            <span>
              Wyrażam zgodę na kontakt w sprawie darmowej konsultacji dotyczącej finansowania i
              ubezpieczeń oraz na przekazanie informacji niezbędnych do przygotowania rozmowy (telefon/e-mail).
            </span>
          </label>
          {showError("consentContact") && (
            <div className="field-error" style={{ color: "#b91c1c", fontSize: 12, marginTop: 6, lineHeight: 1.3 }}>
              {errors.consentContact}
            </div>
          )}
        </div>

        <div className={`form-field checkbox-field ${showError("privacyAccepted") ? "error" : ""}`}>
          <label className="checkbox-option-block">
            <input type="checkbox" name="privacyAccepted" checked={!!formData.privacyAccepted}
              onChange={onChange} onBlur={onBlur} aria-invalid={!!showError("privacyAccepted")} />
            <span>
              Zapoznałem się i akceptuję{" "}
              <span role="button" onClick={() => setShowPrivacy(true)} className="privacy-link">
                politykę prywatności
              </span>{" "}
              Aureus Leasing sp. z o.o.
            </span>
          </label>
          {showError("privacyAccepted") && <div className="field-error" style={errStyle}>{errors.privacyAccepted}</div>}
        </div>

        {/* Przyciski */}
        <div className="navigation-buttons">
          <button onClick={handleSubmit} className="button-green" disabled={isSubmitting}>
            {isSubmitting ? "Wysyłam..." : "Umów konsultację"}
          </button>
        </div>
      </main>

      <footer className="footer">
        <div style={{ marginTop: 40, fontSize: 12, textAlign: "center", color: "#555" }}>
          Aureus Leasing Sp. z o.o., ul. Jasnogórska 3, lok. B4, 44-100 Gliwice, NIP 631 264 4058, REGON 242 799 493.
        </div>
        <button className="underline" onClick={() => setShowPrivacy(true)}>Polityka prywatności</button>
      </footer>

      {showPrivacy && <PrivacyPopup onClose={() => setShowPrivacy(false)} />}
    </div>
  );
}
